import React, { useEffect, useMemo, useState } from "react";
import { ButtonBase, CircularProgress, MenuItem, TextField } from "@material-ui/core";
import styles from "./Style.module.css";
import CustomSelectField from "../../../../components/FormFields/SelectField/SelectField.component";
import { quartersFY } from "../../../../helper/helper";
import { serviceGetList } from "../../../../services/Common.service";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({}));
function HierarchyFields({ form, changeTextData,downloading,handleDownload }) {
  const [listData, setListData] = useState({
    ZONES: [],
    STATES: [],
  });
  const classes = useStyles();
  useEffect(() => {
    serviceGetList(["ZONES", "STATES"]).then((res) => {
      if (!res.error) {
        setListData(res.data);
      }
    });
  }, []);

  const renderMonth = useMemo(() => {
    const { quarter, fy_year } = form || {};
    if (!quarter) return [];

    const selectedQuarters = quartersFY;

    return selectedQuarters[quarter] || [];
  }, [form?.quarter, form?.fy_year]);

  return (
    <div className={styles.container}>
      <div className={styles.filters}>
        <div className={styles.flex}>
          <CustomSelectField
            label={"Year"}
            value={form?.fy_year}
            handleChange={(value) => {
              changeTextData(value, "fy_year");
            }}
          >
            <MenuItem value="2026-2027">FY 2026-2027</MenuItem>
            <MenuItem value="2025-2026">FY 2025-2026</MenuItem>
            <MenuItem value="2024-2025">FY 2024-2025</MenuItem>
            <MenuItem value="2023-2024">FY 2023-2024</MenuItem>
            <MenuItem value="2022-2023">FY 2022-2023</MenuItem>
            <MenuItem value="2021-2022">FY 2021-2022</MenuItem>
          </CustomSelectField>
        </div>
        <div className={styles.flex}>
          <CustomSelectField
            label={"Quarter"}
            value={form?.quarter}
            handleChange={(value) => {
              changeTextData(value, "quarter");
            }}
          >
            <MenuItem value="Q1">Q1</MenuItem>
            <MenuItem value="Q2">Q2</MenuItem>
            <MenuItem value="Q3">Q3</MenuItem>
            <MenuItem value="Q4">Q4</MenuItem>
          </CustomSelectField>
        </div>
        <div className={styles.flex}>
          <CustomSelectField
            label={"Month"}
            value={form?.month}
            handleChange={(value) => {
              changeTextData(value, "month");
            }}
          >
            {renderMonth?.map((val) => (
              <MenuItem value={val?.value} key={`month_${val?.value}`}>
                {val?.name}
              </MenuItem>
            ))}
          </CustomSelectField>
        </div>
        <div className={styles.flex}></div>
        <div className={styles.yearFlex}>
          <div className={styles.rightFlex}>
            <ButtonBase
              className={styles.download}
              onClick={handleDownload}
              disabled={downloading}
            >
              {downloading ? <CircularProgress size={20} /> : "DOWNLOAD"}
            </ButtonBase>
          </div>
        </div>
      </div>
      <br />
    </div>
  );
}

export default HierarchyFields;
